import { GlTooltipDirective, GlIcon, GlAvatar } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { truncate } from '~/lib/utils/text_utility';
import { n__, __ } from '~/locale';
const COUNT_OF_AVATARS_IN_GUTTER = 3;
const LENGTH_OF_AVATAR_TOOLTIP = 17;
const AVATAR_CLASSES = [
    'gl-z-3 group-hover:gl-left-0 gl-delay-0',
    'gl-z-2 group-hover:gl-left-5 gl-delay-[18ms]',
    'gl-z-1 group-hover:gl-left-7 gl-delay-[25ms]',
    'group-hover:gl-left-9 gl-delay-[37ms]'
];
export default {
    name: 'DiffGutterToggle',
    components: {
        GlIcon,
        GlAvatar
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        discussions: {
            type: Array,
            required: true
        },
        expanded: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'toggle'
    ],
    computed: {
        allNotes () {
            return this.discussions.flatMap((d)=>d.notes || []).filter((n)=>!n.isDraft);
        },
        notesInGutter () {
            return this.allNotes.slice(0, COUNT_OF_AVATARS_IN_GUTTER);
        },
        moreCount () {
            return this.allNotes.length - this.notesInGutter.length;
        },
        moreText () {
            if (this.moreCount === 0) return '';
            return n__('%d more comment', '%d more comments', this.moreCount);
        }
    },
    methods: {
        toggle () {
            this.$emit('toggle', this.expanded);
            this.$nextTick(()=>this.$refs.toggle?.focus());
        },
        tooltipText (note) {
            const text = note.note?.length > LENGTH_OF_AVATAR_TOOLTIP ? truncate(note.note, LENGTH_OF_AVATAR_TOOLTIP) : note.note;
            return `${note.author.name}: ${text}`;
        }
    },
    avatarClasses: AVATAR_CLASSES,
    i18n: {
        hideComments: __('Hide comments'),
        showComments: __('Show comments')
    }
};
